import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 3.25A6.75 6.75 0 0 0 5.25 10c0 2.866 1.638 5.537 3.167 7.422a24 24 0 0 0 2.835 2.93l.257.216.016.012.004.004h.002v.001L12 20l-.469.586a.75.75 0 0 0 .938 0L12 20l.469.585.002-.001.004-.004.016-.012a10 10 0 0 0 .257-.216 23.93 23.93 0 0 0 2.835-2.93c1.529-1.885 3.167-4.556 3.167-7.422A6.75 6.75 0 0 0 12 3.25m.422 15.374q-.237.224-.422.388-.185-.165-.422-.389a22 22 0 0 1-1.995-2.145C8.112 14.663 6.75 12.334 6.75 10a5.25 5.25 0 1 1 10.5 0c0 2.334-1.361 4.663-2.833 6.478a22 22 0 0 1-1.995 2.145M12 7.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M10.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }